export default __webpack_public_path__ + "static/media/icn-timing.79393c63.svg";